module.exports = __webpack_public_path__ + "img/216.aebca643.png";